import { useRouteMatch } from 'react-router-dom';
import { Content, ListCell, Image, Icon, Typography } from '@modulor/react';
import cn from 'classnames';
import React from 'react';
import { useActiveCellPaths } from './hooks';
import type { NavigationItem } from '../types';
import SeoLink from '../../../SeoLink/SeoLink';
import { Local } from '../../../Local/Local';
import { MODULOR_FONTS } from '../../../../constants/modulor';
import { isSvg } from '../../../../utils/imagePath';
import styles from './styles.module.css';
import { INSTANT_GAMES } from '../../../../constants/productTypes';

type NavigationCellProps = NavigationItem;

const NavigationCell = ({
  translationKey,
  activeRoutes,
  onItemClick,
  rightCellContent,
  linkPathBuilder,
  id,
  namespace,
  analyticsData,
  productType,
  ...iconSettings
}: NavigationCellProps) => {
  const url = linkPathBuilder(id);
  const activePaths = useActiveCellPaths(activeRoutes, url);

  const match = useRouteMatch({
    path: activePaths,
    exact: true,
  });

  const IconComponent = 'Icon' in iconSettings ? iconSettings.Icon : null;
  const iconPathBuilder =
    'iconPathBuilder' in iconSettings ? iconSettings.iconPathBuilder : null;

  const iconPath = iconPathBuilder ? iconPathBuilder(id) : '';

  const isActiveCell = !!match;
  const isIconSVG = isSvg(iconPath) && !iconSettings?.loadIconAsImage;

  return (
    <SeoLink productType={productType || INSTANT_GAMES} url={url}>
      <ListCell
        // @ts-ignore
        text={
          <Typography
            variant={
              isActiveCell
                ? MODULOR_FONTS.BODY_SEMIBOLD
                : MODULOR_FONTS.BODY_REGULAR
            }
          >
            <Local namespace={namespace}>{translationKey}</Local>
          </Typography>
        }
        dividerHidden
        leftControl={
          IconComponent ? (
            <IconComponent
              className={cn(styles.icon, { [styles.active]: isActiveCell })}
            />
          ) : isIconSVG ? (
            <Icon
              // this is a @modulor/react bug. Icon component cant load image src if there is no name prop :)
              name="not_empty_name"
              src={iconPath}
              className={cn(styles.icon, { [styles.active]: isActiveCell })}
            />
          ) : (
            <Image
              src={iconPath}
              alt={id}
              className={cn(styles.image, styles.icon, {
                [styles.active]: isActiveCell,
              })}
            />
          )
        }
        {...(rightCellContent
          ? {
              content: (
                <Content
                  className={styles.right}
                  text={rightCellContent as string}
                />
              ),
            }
          : {})}
        onClick={() => {
          onItemClick({ id, analyticsData });
        }}
        className={cn(styles.cell, { [styles.active]: isActiveCell })}
      />
    </SeoLink>
  );
};

export default NavigationCell;
